import * as React from 'react';
export const IcSeedling = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17 17c-.479 0-.95.12-1.37.35A4 4 0 0013 15.14V10a2.65 2.65 0 001.72-.79A5.86 5.86 0 0016 5.5a.5.5 0 00-.5-.5 4.66 4.66 0 00-2.73.77A5 5 0 007.5 2a.5.5 0 00-.5.5c0 .12 0 3 1.56 4.52A3.32 3.32 0 0011 8v7.14a4 4 0 00-2.63 2.21A2.87 2.87 0 007 17a3 3 0 00-3 3v1a1 1 0 001 1h14a1 1 0 001-1v-1a3 3 0 00-3-3z'
      fill='currentColor'
    />
  </svg>
);
